import { modalEtatServices, modalSearchExportSuccess } from '../../../core/declare-components';
import { ComponentHelper } from '../../services/component-helper';
import { HuitabPageManager, PageManager } from '../../services/page-manager';
import { PageTypes } from '../../services/settings-loader';
import { StoreManager } from '../../services/store-manager';
import { TacheManager } from '../../services/tache-manager';
import MicroApp from './micro-app-base';

/**
 * Microapp Rechercher compteurs
 */
export default class RechercheCompteursMicroApp extends MicroApp {
  /**
   * Surcharge pour réagir aux messages de la microapp
   */
  childPymEvents = {
    /**
     * Afficher la modal pour montrer la synthèse d´état des services souscrits
     */
    consulterEtatServices: (espaces) => {
      modalEtatServices.show(JSON.parse(espaces));
    },
    /**
     * Affiche la fiche compteur
     * @param {string} params Les paramètres de la fiche compteur au format json
     * Exemple {"idSiren":"213101579","idPrm":"50037429625076"}
     */
    afficherFicheCompteur: (params) => {
      const url = HuitabPageManager.appendParams(PageTypes.FICHE_COMPTEUR.path, JSON.parse(params));
      HuitabPageManager.openLinkInNewTab(url);
    },
    /**
     * Réagit à l'initialisation du frontend recherche compteurs (frontend-mes-prms-clc) et lui retourne le PRM sélectionné
     * Utile dans le cas où le PRM sélectionné a été envoyé avant l'initialisation de ce frontend
     */
    microAppInitialisee: () => {
      const siren = StoreManager.selectedSiren !== 'all' ? StoreManager.selectedSiren : '';
      ComponentHelper.pymSendMessage('changementSiren', siren);
    },
    /**
     * Réagit à l'arrivée d'une nouvelle tache
     * @param {string} jsonTache string JSON au format {"id": string, "libelle": string, "statut": {EN_ATTENTE|TERMINE|ECHOUE}, "version": integer, "type": {FICHIER_CSV}}
     */
    prmSearchExportCsvSuccess: (jsonTache) => {
      const tache = JSON.parse(jsonTache);
      TacheManager.ajouter([tache]);
      modalSearchExportSuccess.show();
    },
    /**
     * Redirige vers la page d'accueil
     * @param {string} openInNewTab true si la page d'accueil doit s'ouvrir dans un nouvel onglet
     */
    retourAccueil: (openInNewTab) => {
      openInNewTab === 'true'
        ? HuitabPageManager.openLinkInNewTab(PageTypes.RACINE.path)
        : PageManager.redirectTo(PageTypes.RACINE);
    },
  };

  /**
   * Initialise une nouvelle instance de type {@type RechercheCompteursMicroApp}.
   */
  constructor() {
    super();
  }
}
